import React from 'react'
import noImage from 'images/no_image.png'

const Image = ({ photo }) => {
  if(photo) {
    return <img className='rounded-circle' height="80" width="80" src={photo} alt='' />
  } else {
    return <img height="80" src={noImage} alt='' />
  }
}

const SpeakerRow = ({ speaker }) => {
  return(
    <div className='user-list speaker'>
      <Image photo={speaker.photo} />
      <div className='user-info'>
        <div className='full-name'>{speaker.first_name} {speaker.last_name}</div>
        <div className='title'>{speaker.title}</div>
        <div className='account-name'>{speaker.crm_account_name}</div>
        <div className='speaker-type'>{speaker.speaker_label_name}</div>
        {speaker.isModerator && <div className='user-moderator'>Moderator</div>}
      </div>
    </div>
  )
}

export default SpeakerRow
